
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta } from "/app/pages/[slug].vue?macro=true";
import { default as LogindCzcISBfl03VgsT2ExMgcth8z27zvssCxIRxv1_45zdukMeta } from "/app/pages/auth/Login.vue?macro=true";
import { default as deal80enWZ3AovSMagf5_boAafW0dVCSycL3sMKGAL4j2zcMeta } from "/app/pages/reports/deal.vue?macro=true";
import { default as lead4CG_45jh3YPqqhoVEl86Twul8_lMd8tUK6upNtMcTZ3RUMeta } from "/app/pages/reports/lead.vue?macro=true";
import { default as taskRJyQqftFxi68vJIvDUfisoeJRVBH4K0Ncq0rSSzQg8AMeta } from "/app/pages/reports/task.vue?macro=true";
import { default as Set_45PasswordhZ9MMmPqt20bo5Ghv7GGAItVElQUFYPVFGA2jahq0aYMeta } from "/app/pages/Set-Password.vue?macro=true";
import { default as lead8Vj9HMDAK_452sbC3cb_45u6CiHJsZIPW00L5sH787mJ6_sMeta } from "/app/pages/setting/lead.vue?macro=true";
import { default as indexYYQ_45YB2qCdn5KIW5iWxSwk07L_452ydzvTFQuV3mPunWcMeta } from "/app/pages/fax/send/index.vue?macro=true";
import { default as ticketp5muAC98jZBG_453qpCYZgzI5YTXWJTtR4RR6ZHrwb3jsMeta } from "/app/pages/reports/ticket.vue?macro=true";
import { default as editZgGjnPnteoXpIowyDFwAqCpbfcvruw_tpwgUSLuF0mQMeta } from "/app/pages/send/bulk/edit.vue?macro=true";
import { default as indexlrbA49aRiZuYwpIVCtmuLvjlCDr8cZM9e_Ilj0meqCwMeta } from "/app/pages/send/otp/index.vue?macro=true";
import { default as people1YDVPGErhtoOeY2hJIf_45W0JMkK1yOBKgdzLnoWhfZnUMeta } from "/app/pages/setting/people.vue?macro=true";
import { default as indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as indexsQcmx7usnmIYaF_OJMI4992vh2ca2GFbrdNRA8cyjD8Meta } from "/app/pages/crm/links/index.vue?macro=true";
import { default as index9igUVy_9ZLQQSqW3LppA6SGpqURAcHLfu150gPTXtmoMeta } from "/app/pages/send/bulk/index.vue?macro=true";
import { default as indexYvWlt25mCbb1dc5hTbAYHBOAu_452nTy3V7d2mwQ8rpnEMeta } from "/app/pages/fax/insert/index.vue?macro=true";
import { default as indexdPCi7McCUT2Vfsqwp_45PLw5Asl74R7ui16nDoFPFWJpUMeta } from "/app/pages/report/cdr/index.vue?macro=true";
import { default as editm0qve_45FM_45Ao05h8ekGx2eZwt8b1sE0Px3T0gYb_6lQoMeta } from "/app/pages/send/groups/edit.vue?macro=true";
import { default as indexoL8m72s26KhiOE1t9kLOQYZMBZYcf402LlWTToZWeucMeta } from "/app/pages/users/list/index.vue?macro=true";
import { default as index9y1INIzas51Zf3umBUCc4kaVC_45wlZxAdw6w_l8_VUokMeta } from "/app/pages/users/role/index.vue?macro=true";
import { default as indexaTzkUM6Lt3Zkki6qM8kLk83jaYumjcSpkKieO6ry3a0Meta } from "/app/pages/crm/numbers/index.vue?macro=true";
import { default as index6gNN_45Y448fiXspekxMMzwfKOw_fZYX1hPaQtdXtypq4Meta } from "/app/pages/report/cost/index.vue?macro=true";
import { default as index_2yHJSRSOqp5VhJBcUuRxjC70I9PHz5JdLiMkV58lxEMeta } from "/app/pages/send/groups/index.vue?macro=true";
import { default as companiesrCli2PyBMoC2KfVWU7WKNcNsQaW5uL8Vr06OtcwCbg4Meta } from "/app/pages/setting/companies.vue?macro=true";
import { default as _91id_93iJE9lb7zKiMG6Rgbm1yP7ZTU_45QhJ3glsiKNRp47T7IsMeta } from "/app/pages/contacts/deal/[id].vue?macro=true";
import { default as _91id_93HZmPd0ODaiMxhRq0uoWANobhB_Brae8tZDhApT_451MesMeta } from "/app/pages/contacts/lead/[id].vue?macro=true";
import { default as indexFyQ0rrdT3LneRxMnLmG51npdiwCgVf_ADSK53ZvFbWUMeta } from "/app/pages/crm/settings/index.vue?macro=true";
import { default as indexpbQbb4lFiTT07It1qtOz3U7ERGCixnvNu8OLkufWL7sMeta } from "/app/pages/fax/received/index.vue?macro=true";
import { default as indexMsE08Ynf_MwSm_45uUkWJeTWAVj_45fHh6PvR79eNH_451mHsMeta } from "/app/pages/notification/index.vue?macro=true";
import { default as indexA6T10Dwptouyu6xEfi_L_VPYQI03_45OJ2vLUM3BJlFp0Meta } from "/app/pages/report/calls/index.vue?macro=true";
import { default as createvW_a2dH94qhjk70EYneGK4jsKu44NhpuvFJrLNV9XbUMeta } from "/app/pages/send/groups/create.vue?macro=true";
import { default as indexFe_4538YhsS4Etxu2gGjhR2myM2d4CPMgEg2lvuBjncwgMeta } from "/app/pages/settings/ivr/index.vue?macro=true";
import { default as indexj9ln_cHo7CRC6SHqk8z3RkveNfp9hgtqz4p2MgpOyW0Meta } from "/app/pages/users/access/index.vue?macro=true";
import { default as index8wEaZEraVR79mkSxw_45c_h2v_ExCTsOUQekcipkA4QgYMeta } from "/app/pages/webchat/role/index.vue?macro=true";
import { default as index5Zf9hoWqiMalFsx2VThrNkY6DSicu8u5JUaQ_45YtqDhgMeta } from "/app/pages/webchat/User/index.vue?macro=true";
import { default as indexc2uun_yis_45zVf7jGO60IbbCDeugJm12ohGJ3ncW_8e8Meta } from "/app/pages/contacts/deal/index.vue?macro=true";
import { default as indexl4oeIsXxEigrLHYo2nq1EGwF2UTnVpNPHz9Cr5Fe0F8Meta } from "/app/pages/contacts/lead/index.vue?macro=true";
import { default as indexCdnYipRZnzOtiPelOCLpzutViUy_45kMi_1KKI0q0Vh_454Meta } from "/app/pages/fax/submitted/index.vue?macro=true";
import { default as indexD8IJdrLFh3x43tOHteqmcu70GIFHSNLeR3s3J5zbQC4Meta } from "/app/pages/report/rating/index.vue?macro=true";
import { default as indexCGdDF4aG0gIquC7sybQSVIild5ozSicGZAUjnyvfvPMMeta } from "/app/pages/users/message/index.vue?macro=true";
import { default as Forgot_45PasswordGn_45Sz8h_53sx6kkP_mZa7fSFjDnCiwQknuQweTp_451J0Meta } from "/app/pages/auth/Forgot-Password.vue?macro=true";
import { default as _91id_93BloLElqsznBRP8zXwuktZOQutONMCdxj5WreveXnKMEMeta } from "/app/pages/contacts/people/[id].vue?macro=true";
import { default as index95UvF7hx4MKr864tppTq4bzzC6hFVzFSCPlNpZbD6EQMeta } from "/app/pages/contacts/tasks/index.vue?macro=true";
import { default as _91id_93L_BwYVGghwN2arZSDyftf_dGV_WF5MxKdIiKc4NuK34Meta } from "/app/pages/contacts/ticket/[id].vue?macro=true";
import { default as edit09f41WLZqxV0k1fmiIsCD7YPohq591gWmuO13wwEHycMeta } from "/app/pages/evaluation/save/edit.vue?macro=true";
import { default as viewmny40S16Oj_45GdZWZmfeJrPE_hhDTMeKuTqN6dP0hLV0Meta } from "/app/pages/evaluation/save/view.vue?macro=true";
import { default as indexi8DeuMmdXblIDwpwzkJol8BkbLYW2REbeCTsiAEuIW8Meta } from "/app/pages/report/waiting/index.vue?macro=true";
import { default as editj9Hs9iXmNExnXvYKp2HdsGOvBkY58he2CVxg6rMljo4Meta } from "/app/pages/send/parametric/edit.vue?macro=true";
import { default as indexvVcbUfoYOMI1txop3jkhlcYHFgKUeFVVtNc6r4yL1xgMeta } from "/app/pages/setting/ticket/index.vue?macro=true";
import { default as indexDW_tBj_455ttkA0HXqtJNPRz0FJvxBrPDMTDk6m3tybZIMeta } from "/app/pages/settings/queue/index.vue?macro=true";
import { default as indexl3PitcBwuaalmsFzyAYMJGZmQswFNkNJjU0VVwJ4eTAMeta } from "/app/pages/users/operator/index.vue?macro=true";
import { default as index24mZKAFyDuxztRToMDSsY4xdNg0bzrfhUd9JL5olEVcMeta } from "/app/pages/users/whatsapp/index.vue?macro=true";
import { default as indexaJjlazSqYxClY3kNs5GPn9xukVGj0RoKVcSSXe0hO34Meta } from "/app/pages/webchat/Number/index.vue?macro=true";
import { default as _91id_93FjJa9IeMaS5uH5DXJqvpJSuudlYiKTvvqTQJQVIF_455QMeta } from "/app/pages/contacts/company/[id].vue?macro=true";
import { default as formmP65q3y1y4VEMYk8iXUi0QAvZgICOZkQ7h2FOt1P_E4Meta } from "/app/pages/contacts/invoice/form.vue?macro=true";
import { default as indexg_45w8_C_B_45CzW6i0olEnvSYAG97cJUtRuYE_45gbYQPaPkMeta } from "/app/pages/contacts/people/index.vue?macro=true";
import { default as index5_C0D3e8BwzBiijAjfJflltcxG_45DpE4mvbSmhJZlBRQMeta } from "/app/pages/contacts/ticket/index.vue?macro=true";
import { default as adminq8qpHco5eW3sz5rzJ5POPAcjZ64ej1tpik2d23sL4ewMeta } from "/app/pages/evaluation/save/admin.vue?macro=true";
import { default as indexbeW5zniQZvpl26vjIKW3vsihM0uupbyMHGz2GW_45QklkMeta } from "/app/pages/evaluation/save/index.vue?macro=true";
import { default as indexDf3ru9JKlGJPdbpGTNt_45L1pmTVuMxwsFz8r_OU3Al2kMeta } from "/app/pages/evaluation/user/index.vue?macro=true";
import { default as indexgmECgyeYieCOLz_GawLi9cXYWaF4lIXTch3Pup76yRcMeta } from "/app/pages/monitoring/call/index.vue?macro=true";
import { default as index_DM4LaZiudSNZhIsXLMeDQb393f2ZalBEeot9kREd4YMeta } from "/app/pages/report/answered/index.vue?macro=true";
import { default as indexWr3tJOzvuvPH6InyhQq8hGoQpSF4UeJFpAOddrr_45v_45AMeta } from "/app/pages/report/fullCdrs/index.vue?macro=true";
import { default as indexzXApz3eSqIF3gCwU3fGIiaL_h7W1kPFtnjWLw75Wzk8Meta } from "/app/pages/send/parametric/index.vue?macro=true";
import { default as indexaxEm4x8CEzczh002jFw_45ybKafwOfRbjKA6ZUEmTdfR0Meta } from "/app/pages/send/phone-book/index.vue?macro=true";
import { default as _91id_93sOjlAHHDThj5t70vSb99JzqwgabxsHH9roEiHcSo6OsMeta } from "/app/pages/send/report-send/[id].vue?macro=true";
import { default as editP0by964BwNjdkPl9yFun_Khhco5SP_rppYsqqCc0VScMeta } from "/app/pages/send/send-single/edit.vue?macro=true";
import { default as indexKI0bnCP6LbOBPECT_45S8OTc9nUxH_45lM0xEsj9ZN8yz4gMeta } from "/app/pages/support/tickets/index.vue?macro=true";
import { default as index9kUzO8kj4FORgCslqRhd84oDrnbUXhd_45QVhyYaB8BQ0Meta } from "/app/pages/contacts/company/index.vue?macro=true";
import { default as archived_F_45bU8rvohxJVA7fdagRoFO2gcL9sA2zh5gPSFB6R6IMeta } from "/app/pages/contacts/deal/archived.vue?macro=true";
import { default as index_4508gjUlQjqrp6H05TK_fORmktDaVeOQeceaWd_45Co688Meta } from "/app/pages/contacts/invoice/index.vue?macro=true";
import { default as archivedHX1dpUT63QvoB7y6uDJuEYeLqfCHmgkKc0A5eTepDaMMeta } from "/app/pages/contacts/lead/archived.vue?macro=true";
import { default as expertgSIEhJ6JIET8mPJIThsYSrUBKeIaS_ujXH32cwB5NHwMeta } from "/app/pages/evaluation/save/expert.vue?macro=true";
import { default as indexkrpBOwvXvNUdT8DTIeZ8L3kP_1xSG4jq_45a_458fGYy9R8Meta } from "/app/pages/monitoring/users/index.vue?macro=true";
import { default as indexDjhxoRFVwp9Y8Iy4MxYX2ykgQfiD4c4M2_45Kib1_45V8uUMeta } from "/app/pages/send/report-send/index.vue?macro=true";
import { default as indexhIoleA8PbOmsFU5OYBNeGw_3HvN5PlxclxQB2Yf7CoIMeta } from "/app/pages/send/send-single/index.vue?macro=true";
import { default as indexes1XGvoa5xaqAzvJtWz_45cjr_1YNhUSkEogEx_45WCiDSsMeta } from "/app/pages/settings/forward/index.vue?macro=true";
import { default as indexFPKUBEzWD6efTLWFCWX6rwe1wXZOPUWen44bZuJFtx8Meta } from "/app/pages/users/department/index.vue?macro=true";
import { default as indexBSeUfv3UamjIspg3Rzs6Y12BRkHzUtv3Pzrnkg14iuUMeta } from "/app/pages/webchat/Settings/index.vue?macro=true";
import { default as _91id_93TurNJ0Q2NE0Q_XhWbuSozkCGLaAPUbYLURdIMGWf_l0Meta } from "/app/pages/contacts/inventory/[id].vue?macro=true";
import { default as indexZS3srzFXsrcPux2qjXSLcN9_9_vOyKKpoIhofzb3NT0Meta } from "/app/pages/contacts/products/index.vue?macro=true";
import { default as indexLHVklwfO11lLQx0bgRTVQH5VHp6_45CmfaEpdfdaRJo6UMeta } from "/app/pages/contacts/timeLine/index.vue?macro=true";
import { default as indexWA3LnIioyKI_qSlrng4Ol23q7qXZQqum4RRLcLMIAnMMeta } from "/app/pages/contacts/whatsapp/index.vue?macro=true";
import { default as indexPxQlYnkJRit8KoWusdb5Lxc8Y4HGH10h9YMo8D5vJe4Meta } from "/app/pages/evaluation/report/index.vue?macro=true";
import { default as indexv5er_458EmnSRXYgPQEdedqnqB34BR7eI7ObN4GnuZJMEMeta } from "/app/pages/report/scatteirng/index.vue?macro=true";
import { default as editNB6itS72Q0qsfLx4N8WV3AH9sDR8FXZunO91ltPyTg4Meta } from "/app/pages/send/corresponding/edit.vue?macro=true";
import { default as _91id_93mYO51_iRsYspzk752xdKjgWJYSaNl5gzJZebSGNNM24Meta } from "/app/pages/settings/voiceMail/[id].vue?macro=true";
import { default as indexGQhUlQHHpmyyVxaf9SMnD_45f3fhV99MFEjd0S_45P7EJeEMeta } from "/app/pages/webchat/Customize/index.vue?macro=true";
import { default as indexjUv44k7_45pxkizWGkIAzo_45DAoQnpW7F16Xt5nCY4VrnYMeta } from "/app/pages/webchat/dashboard/index.vue?macro=true";
import { default as index_32copyQn0dwlxViNIPkEi6s3msY_45iI3IeN_gAYg2AxSGKhNwYMeta } from "/app/pages/webchat/User/index copy.vue?macro=true";
import { default as indexh7Pvff5iDvwewlylRn1Rk830lIkdVkFX5_uL0N3BxyoMeta } from "/app/pages/contacts/inventory/index.vue?macro=true";
import { default as settingvwPkusNUs03gTKdsSXYP_MLqAn7uiM9hJE3RocNzQgkMeta } from "/app/pages/contacts/invoice/setting.vue?macro=true";
import { default as archivedaKhMBIf9VJdtBz1xsU7Y3l4vRDVdXjymYFMWQ8yZU0UMeta } from "/app/pages/contacts/ticket/archived.vue?macro=true";
import { default as indexrjTAvw_q5v57GrEDFGPXT195wySm3dW2LNZGJABxfDAMeta } from "/app/pages/report/missedCalls/index.vue?macro=true";
import { default as indexe3q0AZVULS98wgy4XPlcNJNMLQqtM8hbzKOmNRH5t5wMeta } from "/app/pages/send/corresponding/index.vue?macro=true";
import { default as indexl18DPy6Ph90KKxou9gbCMFzkxvbK1DzUQYPPTkyMaA8Meta } from "/app/pages/settings/blackList/index.vue?macro=true";
import { default as indexe4fG35HK6d9uEHiEAXdiFYYSwvjvx8Ih642JmkaGCdYMeta } from "/app/pages/settings/recording/index.vue?macro=true";
import { default as indexiOGDQ0DqriWiDEhaNVvWS9Z6kZx2QJtA7P6xX9s4_45eQMeta } from "/app/pages/settings/voiceMail/index.vue?macro=true";
import { default as indexleMSZzFHUpMuwvPN8O2OFwAd7Lmzgq_45GaIl6C_fhPJwMeta } from "/app/pages/webchat/Department/index.vue?macro=true";
import { default as indexr0p185vqwq2pyVb0IQ_rBnlGuZRD_45r8_Qe_aCskcfCUMeta } from "/app/pages/automation/workflow/index.vue?macro=true";
import { default as archivedvF1uT_45qEgiGJ8mTcucUnYCm_nuIEAAsQag58vlzV2pwMeta } from "/app/pages/contacts/invoice/archived.vue?macro=true";
import { default as index8P8boiksRjPTjQf2BalWsKjlnPz3IT6TMrI0eH1c2owMeta } from "/app/pages/report/hangupReason/index.vue?macro=true";
import { default as indexsEh2nz9807o0gn6cG7yNSUHJMCAOvxQIRrOlrrOT1r4Meta } from "/app/pages/send/report-receive/index.vue?macro=true";
import { default as indexxlkDEAQfm5W7OJHU_oY_45mG_AzLwV9dM3J7U4DkDBkywMeta } from "/app/pages/monitoring/wallboard/index.vue?macro=true";
import { default as index8LDOxcfCX_iniKIX36GcO974Q2CWwJr9sBdp66ERZ5gMeta } from "/app/pages/settings/callRatings/index.vue?macro=true";
import { default as indexm5zolY_aLC_45QEwBENYT0SQOcWbte5cg1gZ8_456pE7DksMeta } from "/app/pages/settings/destination/index.vue?macro=true";
import { default as _91id_93ui2YYeS93AbXjfQSoOchl1vo4jwpwSxd9Xipte5wy4QMeta } from "/app/pages/send/phone-book/groups/[id].vue?macro=true";
import { default as indexprtUX9_45OzujPDe2_45grCE3DuucJJwapiQFVsVvOA5heEMeta } from "/app/pages/webchat/conversations/index.vue?macro=true";
import { default as indexDwQLiolwbhd50t45_45UabYZYX6m_duSda_45pylDRpYLIkMeta } from "/app/pages/settings/callRecording/index.vue?macro=true";
import { default as index8IdTxy5G4pVQ1tmVcaTnjNP6Xugp2fdlVyi8PN5HSN4Meta } from "/app/pages/settings/timeCondition/index.vue?macro=true";
import { default as indexwd9eOCWyDaP4OYD_45A4Qlmie_45s5_452lROX5Pxw6lP_jAcMeta } from "/app/pages/users/whatsappMessages/index.vue?macro=true";
import { default as index7hT6TlEtUMSBCm3Rh9UnR5EUi5A36gywvI_8TiKEpwQMeta } from "/app/pages/videoConference/report/index.vue?macro=true";
import { default as index_32copyU2dcIFwWh_45KLT_45ghLSZsniDWu9ltFfYJ1Fcoe_Gbs_45QMeta } from "/app/pages/webchat/Customize/index copy.vue?macro=true";
import { default as indexflDMB0wC67MF9YrSICMPw_OwPdChGoKi3_aC8L8njRsMeta } from "/app/pages/report/operatorActivity/index.vue?macro=true";
import { default as reactiveDataDUs4H74jsz8w5T48f1EwbbwOQeuXT60H93pwbwO1d2AMeta } from "/app/pages/webchat/Customize/reactiveData.ts?macro=true";
import { default as indexaxld8lWPQIGGbgtchfRD_45igpXvhofnXzH_npWyQ_45U9cMeta } from "/app/pages/videoConference/createLink/index.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta || {},
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "auth-Login",
    path: "/auth/Login",
    meta: LogindCzcISBfl03VgsT2ExMgcth8z27zvssCxIRxv1_45zdukMeta || {},
    component: () => import("/app/pages/auth/Login.vue")
  },
  {
    name: "reports-deal",
    path: "/reports/deal",
    component: () => import("/app/pages/reports/deal.vue")
  },
  {
    name: "reports-lead",
    path: "/reports/lead",
    component: () => import("/app/pages/reports/lead.vue")
  },
  {
    name: "reports-task",
    path: "/reports/task",
    component: () => import("/app/pages/reports/task.vue")
  },
  {
    name: "Set-Password",
    path: "/Set-Password",
    meta: Set_45PasswordhZ9MMmPqt20bo5Ghv7GGAItVElQUFYPVFGA2jahq0aYMeta || {},
    component: () => import("/app/pages/Set-Password.vue")
  },
  {
    name: "setting-lead",
    path: "/setting/lead",
    component: () => import("/app/pages/setting/lead.vue")
  },
  {
    name: "fax-send",
    path: "/fax/send",
    component: () => import("/app/pages/fax/send/index.vue")
  },
  {
    name: "reports-ticket",
    path: "/reports/ticket",
    component: () => import("/app/pages/reports/ticket.vue")
  },
  {
    name: "send-bulk-edit",
    path: "/send/bulk/edit",
    component: () => import("/app/pages/send/bulk/edit.vue")
  },
  {
    name: "send-otp",
    path: "/send/otp",
    component: () => import("/app/pages/send/otp/index.vue")
  },
  {
    name: "setting-people",
    path: "/setting/people",
    component: () => import("/app/pages/setting/people.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: "crm-links",
    path: "/crm/links",
    component: () => import("/app/pages/crm/links/index.vue")
  },
  {
    name: "send-bulk",
    path: "/send/bulk",
    component: () => import("/app/pages/send/bulk/index.vue")
  },
  {
    name: "fax-insert",
    path: "/fax/insert",
    component: () => import("/app/pages/fax/insert/index.vue")
  },
  {
    name: "report-cdr",
    path: "/report/cdr",
    component: () => import("/app/pages/report/cdr/index.vue")
  },
  {
    name: "send-groups-edit",
    path: "/send/groups/edit",
    component: () => import("/app/pages/send/groups/edit.vue")
  },
  {
    name: "users-list",
    path: "/users/list",
    component: () => import("/app/pages/users/list/index.vue")
  },
  {
    name: "users-role",
    path: "/users/role",
    component: () => import("/app/pages/users/role/index.vue")
  },
  {
    name: "crm-numbers",
    path: "/crm/numbers",
    component: () => import("/app/pages/crm/numbers/index.vue")
  },
  {
    name: "report-cost",
    path: "/report/cost",
    component: () => import("/app/pages/report/cost/index.vue")
  },
  {
    name: "send-groups",
    path: "/send/groups",
    component: () => import("/app/pages/send/groups/index.vue")
  },
  {
    name: "setting-companies",
    path: "/setting/companies",
    component: () => import("/app/pages/setting/companies.vue")
  },
  {
    name: "contacts-deal-id",
    path: "/contacts/deal/:id()",
    component: () => import("/app/pages/contacts/deal/[id].vue")
  },
  {
    name: "contacts-lead-id",
    path: "/contacts/lead/:id()",
    component: () => import("/app/pages/contacts/lead/[id].vue")
  },
  {
    name: "crm-settings",
    path: "/crm/settings",
    component: () => import("/app/pages/crm/settings/index.vue")
  },
  {
    name: "fax-received",
    path: "/fax/received",
    component: () => import("/app/pages/fax/received/index.vue")
  },
  {
    name: "notification",
    path: "/notification",
    component: () => import("/app/pages/notification/index.vue")
  },
  {
    name: "report-calls",
    path: "/report/calls",
    component: () => import("/app/pages/report/calls/index.vue")
  },
  {
    name: "send-groups-create",
    path: "/send/groups/create",
    component: () => import("/app/pages/send/groups/create.vue")
  },
  {
    name: "settings-ivr",
    path: "/settings/ivr",
    component: () => import("/app/pages/settings/ivr/index.vue")
  },
  {
    name: "users-access",
    path: "/users/access",
    component: () => import("/app/pages/users/access/index.vue")
  },
  {
    name: "webchat-role",
    path: "/webchat/role",
    component: () => import("/app/pages/webchat/role/index.vue")
  },
  {
    name: "webchat-User",
    path: "/webchat/User",
    component: () => import("/app/pages/webchat/User/index.vue")
  },
  {
    name: "contacts-deal",
    path: "/contacts/deal",
    component: () => import("/app/pages/contacts/deal/index.vue")
  },
  {
    name: "contacts-lead",
    path: "/contacts/lead",
    component: () => import("/app/pages/contacts/lead/index.vue")
  },
  {
    name: "fax-submitted",
    path: "/fax/submitted",
    component: () => import("/app/pages/fax/submitted/index.vue")
  },
  {
    name: "report-rating",
    path: "/report/rating",
    component: () => import("/app/pages/report/rating/index.vue")
  },
  {
    name: "users-message",
    path: "/users/message",
    component: () => import("/app/pages/users/message/index.vue")
  },
  {
    name: "auth-Forgot-Password",
    path: "/auth/Forgot-Password",
    meta: Forgot_45PasswordGn_45Sz8h_53sx6kkP_mZa7fSFjDnCiwQknuQweTp_451J0Meta || {},
    component: () => import("/app/pages/auth/Forgot-Password.vue")
  },
  {
    name: "contacts-people-id",
    path: "/contacts/people/:id()",
    component: () => import("/app/pages/contacts/people/[id].vue")
  },
  {
    name: "contacts-tasks",
    path: "/contacts/tasks",
    component: () => import("/app/pages/contacts/tasks/index.vue")
  },
  {
    name: "contacts-ticket-id",
    path: "/contacts/ticket/:id()",
    component: () => import("/app/pages/contacts/ticket/[id].vue")
  },
  {
    name: "evaluation-save-edit",
    path: "/evaluation/save/edit",
    component: () => import("/app/pages/evaluation/save/edit.vue")
  },
  {
    name: "evaluation-save-view",
    path: "/evaluation/save/view",
    component: () => import("/app/pages/evaluation/save/view.vue")
  },
  {
    name: "report-waiting",
    path: "/report/waiting",
    component: () => import("/app/pages/report/waiting/index.vue")
  },
  {
    name: "send-parametric-edit",
    path: "/send/parametric/edit",
    component: () => import("/app/pages/send/parametric/edit.vue")
  },
  {
    name: "setting-ticket",
    path: "/setting/ticket",
    component: () => import("/app/pages/setting/ticket/index.vue")
  },
  {
    name: "settings-queue",
    path: "/settings/queue",
    component: () => import("/app/pages/settings/queue/index.vue")
  },
  {
    name: "users-operator",
    path: "/users/operator",
    component: () => import("/app/pages/users/operator/index.vue")
  },
  {
    name: "users-whatsapp",
    path: "/users/whatsapp",
    component: () => import("/app/pages/users/whatsapp/index.vue")
  },
  {
    name: "webchat-Number",
    path: "/webchat/Number",
    component: () => import("/app/pages/webchat/Number/index.vue")
  },
  {
    name: "contacts-company-id",
    path: "/contacts/company/:id()",
    component: () => import("/app/pages/contacts/company/[id].vue")
  },
  {
    name: "contacts-invoice-form",
    path: "/contacts/invoice/form",
    component: () => import("/app/pages/contacts/invoice/form.vue")
  },
  {
    name: "contacts-people",
    path: "/contacts/people",
    component: () => import("/app/pages/contacts/people/index.vue")
  },
  {
    name: "contacts-ticket",
    path: "/contacts/ticket",
    component: () => import("/app/pages/contacts/ticket/index.vue")
  },
  {
    name: "evaluation-save-admin",
    path: "/evaluation/save/admin",
    component: () => import("/app/pages/evaluation/save/admin.vue")
  },
  {
    name: "evaluation-save",
    path: "/evaluation/save",
    component: () => import("/app/pages/evaluation/save/index.vue")
  },
  {
    name: "evaluation-user",
    path: "/evaluation/user",
    component: () => import("/app/pages/evaluation/user/index.vue")
  },
  {
    name: "monitoring-call",
    path: "/monitoring/call",
    component: () => import("/app/pages/monitoring/call/index.vue")
  },
  {
    name: "report-answered",
    path: "/report/answered",
    component: () => import("/app/pages/report/answered/index.vue")
  },
  {
    name: "report-fullCdrs",
    path: "/report/fullCdrs",
    component: () => import("/app/pages/report/fullCdrs/index.vue")
  },
  {
    name: "send-parametric",
    path: "/send/parametric",
    component: () => import("/app/pages/send/parametric/index.vue")
  },
  {
    name: "send-phone-book",
    path: "/send/phone-book",
    component: () => import("/app/pages/send/phone-book/index.vue")
  },
  {
    name: "send-report-send-id",
    path: "/send/report-send/:id()",
    component: () => import("/app/pages/send/report-send/[id].vue")
  },
  {
    name: "send-send-single-edit",
    path: "/send/send-single/edit",
    component: () => import("/app/pages/send/send-single/edit.vue")
  },
  {
    name: "support-tickets",
    path: "/support/tickets",
    component: () => import("/app/pages/support/tickets/index.vue")
  },
  {
    name: "contacts-company",
    path: "/contacts/company",
    component: () => import("/app/pages/contacts/company/index.vue")
  },
  {
    name: "contacts-deal-archived",
    path: "/contacts/deal/archived",
    component: () => import("/app/pages/contacts/deal/archived.vue")
  },
  {
    name: "contacts-invoice",
    path: "/contacts/invoice",
    component: () => import("/app/pages/contacts/invoice/index.vue")
  },
  {
    name: "contacts-lead-archived",
    path: "/contacts/lead/archived",
    component: () => import("/app/pages/contacts/lead/archived.vue")
  },
  {
    name: "evaluation-save-expert",
    path: "/evaluation/save/expert",
    component: () => import("/app/pages/evaluation/save/expert.vue")
  },
  {
    name: "monitoring-users",
    path: "/monitoring/users",
    component: () => import("/app/pages/monitoring/users/index.vue")
  },
  {
    name: "send-report-send",
    path: "/send/report-send",
    component: () => import("/app/pages/send/report-send/index.vue")
  },
  {
    name: "send-send-single",
    path: "/send/send-single",
    component: () => import("/app/pages/send/send-single/index.vue")
  },
  {
    name: "settings-forward",
    path: "/settings/forward",
    component: () => import("/app/pages/settings/forward/index.vue")
  },
  {
    name: "users-department",
    path: "/users/department",
    component: () => import("/app/pages/users/department/index.vue")
  },
  {
    name: "webchat-Settings",
    path: "/webchat/Settings",
    component: () => import("/app/pages/webchat/Settings/index.vue")
  },
  {
    name: "contacts-inventory-id",
    path: "/contacts/inventory/:id()",
    component: () => import("/app/pages/contacts/inventory/[id].vue")
  },
  {
    name: "contacts-products",
    path: "/contacts/products",
    component: () => import("/app/pages/contacts/products/index.vue")
  },
  {
    name: "contacts-timeLine",
    path: "/contacts/timeLine",
    component: () => import("/app/pages/contacts/timeLine/index.vue")
  },
  {
    name: "contacts-whatsapp",
    path: "/contacts/whatsapp",
    component: () => import("/app/pages/contacts/whatsapp/index.vue")
  },
  {
    name: "evaluation-report",
    path: "/evaluation/report",
    component: () => import("/app/pages/evaluation/report/index.vue")
  },
  {
    name: "report-scatteirng",
    path: "/report/scatteirng",
    component: () => import("/app/pages/report/scatteirng/index.vue")
  },
  {
    name: "send-corresponding-edit",
    path: "/send/corresponding/edit",
    component: () => import("/app/pages/send/corresponding/edit.vue")
  },
  {
    name: "settings-voiceMail-id",
    path: "/settings/voiceMail/:id()",
    component: () => import("/app/pages/settings/voiceMail/[id].vue")
  },
  {
    name: "webchat-Customize",
    path: "/webchat/Customize",
    component: () => import("/app/pages/webchat/Customize/index.vue")
  },
  {
    name: "webchat-dashboard",
    path: "/webchat/dashboard",
    component: () => import("/app/pages/webchat/dashboard/index.vue")
  },
  {
    name: "webchat-User-index copy",
    path: "/webchat/User/index%20copy",
    component: () => import("/app/pages/webchat/User/index copy.vue")
  },
  {
    name: "contacts-inventory",
    path: "/contacts/inventory",
    component: () => import("/app/pages/contacts/inventory/index.vue")
  },
  {
    name: "contacts-invoice-setting",
    path: "/contacts/invoice/setting",
    component: () => import("/app/pages/contacts/invoice/setting.vue")
  },
  {
    name: "contacts-ticket-archived",
    path: "/contacts/ticket/archived",
    component: () => import("/app/pages/contacts/ticket/archived.vue")
  },
  {
    name: "report-missedCalls",
    path: "/report/missedCalls",
    component: () => import("/app/pages/report/missedCalls/index.vue")
  },
  {
    name: "send-corresponding",
    path: "/send/corresponding",
    component: () => import("/app/pages/send/corresponding/index.vue")
  },
  {
    name: "settings-blackList",
    path: "/settings/blackList",
    component: () => import("/app/pages/settings/blackList/index.vue")
  },
  {
    name: "settings-recording",
    path: "/settings/recording",
    component: () => import("/app/pages/settings/recording/index.vue")
  },
  {
    name: "settings-voiceMail",
    path: "/settings/voiceMail",
    component: () => import("/app/pages/settings/voiceMail/index.vue")
  },
  {
    name: "webchat-Department",
    path: "/webchat/Department",
    component: () => import("/app/pages/webchat/Department/index.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/workflow",
    component: () => import("/app/pages/automation/workflow/index.vue")
  },
  {
    name: "contacts-invoice-archived",
    path: "/contacts/invoice/archived",
    component: () => import("/app/pages/contacts/invoice/archived.vue")
  },
  {
    name: "report-hangupReason",
    path: "/report/hangupReason",
    component: () => import("/app/pages/report/hangupReason/index.vue")
  },
  {
    name: "send-report-receive",
    path: "/send/report-receive",
    component: () => import("/app/pages/send/report-receive/index.vue")
  },
  {
    name: "monitoring-wallboard",
    path: "/monitoring/wallboard",
    component: () => import("/app/pages/monitoring/wallboard/index.vue")
  },
  {
    name: "settings-callRatings",
    path: "/settings/callRatings",
    component: () => import("/app/pages/settings/callRatings/index.vue")
  },
  {
    name: "settings-destination",
    path: "/settings/destination",
    component: () => import("/app/pages/settings/destination/index.vue")
  },
  {
    name: "send-phone-book-groups-id",
    path: "/send/phone-book/groups/:id()",
    component: () => import("/app/pages/send/phone-book/groups/[id].vue")
  },
  {
    name: "webchat-conversations",
    path: "/webchat/conversations",
    component: () => import("/app/pages/webchat/conversations/index.vue")
  },
  {
    name: "settings-callRecording",
    path: "/settings/callRecording",
    component: () => import("/app/pages/settings/callRecording/index.vue")
  },
  {
    name: "settings-timeCondition",
    path: "/settings/timeCondition",
    component: () => import("/app/pages/settings/timeCondition/index.vue")
  },
  {
    name: "users-whatsappMessages",
    path: "/users/whatsappMessages",
    component: () => import("/app/pages/users/whatsappMessages/index.vue")
  },
  {
    name: "videoConference-report",
    path: "/videoConference/report",
    component: () => import("/app/pages/videoConference/report/index.vue")
  },
  {
    name: "webchat-Customize-index copy",
    path: "/webchat/Customize/index%20copy",
    component: () => import("/app/pages/webchat/Customize/index copy.vue")
  },
  {
    name: "report-operatorActivity",
    path: "/report/operatorActivity",
    component: () => import("/app/pages/report/operatorActivity/index.vue")
  },
  {
    name: "webchat-Customize-reactiveData",
    path: "/webchat/Customize/reactiveData",
    component: () => import("/app/pages/webchat/Customize/reactiveData.ts")
  },
  {
    name: "videoConference-createLink",
    path: "/videoConference/createLink",
    component: () => import("/app/pages/videoConference/createLink/index.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/monitoring/dashboard",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]